import { useContext } from "react";
import { AppContext } from "../helpers/contexts/AppContext";

const useAuth = () => {
  return useContext(AppContext);
};

export default useAuth;
